import * as React from 'react'
import { useCallback } from 'react'
import { QCProvider } from '../InspectionBacklog/QCContext'
import { RequestCard } from '../InspectionBacklog/RequestCard'
import { QCBacklogList } from '../InspectionBacklog/WorkItemHierarchy/QCBacklogList'
import { useInspectionsLogContext } from './InspectionsLogContext'
import { Box, Pagination, Skeleton, Typography } from '@mui/material'

const SKELETON_SX = { mx: 4 } as const

export default function RequestsList() {
	const { requests, requestsLoading, totalRequestCount, filters, setFilters, loadRequests } =
		useInspectionsLogContext()
	const handlePageChange = useCallback(
		(_: React.ChangeEvent<unknown>, page: number) => {
			setFilters((prev) => ({ ...prev, page }))
		},
		[setFilters],
	)
	return (
		<Box display='flex' flexDirection='column' height='100%'>
			<Box
				sx={{
					flex: 1,
					display: 'flex',
					overflowY: 'auto',
					flexDirection: 'column',
					gap: 2,
				}}
			>
				{requestsLoading
					? Array.from({ length: 5 }, (_, index) => (
							<Skeleton
								variant='rounded'
								key={index}
								width={'auto'}
								height={100}
								sx={SKELETON_SX}
								animation='wave'
							/>
					  ))
					: requests?.length === 0 ? (
						<Box
							display="flex"
							flexDirection="column"
							alignItems="center"
							justifyContent="center"
							sx={{ p: 4 }}
						>
							<Typography variant="h6" color="text.secondary" gutterBottom>
								No Inspection Requests Found
							</Typography>
							<Typography variant="body2" color="text.secondary" align="center">
								There are currently no inspection requests that match your filters.
							</Typography>
						</Box>
					) : requests?.map((item) => (
							<QCProvider key={item.request.id} hierarchy={item.hierarchy}>
								<RequestCard request={item.request} showAssignee loadParentData={loadRequests}>
									<QCBacklogList hierarchy={item.hierarchy} />
								</RequestCard>
							</QCProvider>
					  ))}
			</Box>
			<Box
				sx={{
					position: 'sticky',
					bottom: 0,
					backgroundColor: 'white',
					py: 1,
					zIndex: 10,
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
				}}
			>
				<Pagination
					count={Math.ceil(totalRequestCount / 25)}
					variant='outlined'
					shape='rounded'
					size='large'
					onChange={handlePageChange}
					page={filters.page}
				/>
			</Box>
		</Box>
	)
}
